import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            selectedUser: null,
            chooseUser: false,
            currentCredits: 0,
            userToAddCredit: null,
            userAddCredits: false,
            selectedButton: 'ACTIVE',
            userCredits: []
        }
    },
    methods: {
        deleteCredit: deleteCredit,
        chooseUserDialog: chooseUserDialog,
        addCredits: addCredits,
        formatDate: formatDate,
        takeCredits: takeCredits,
        loadCreditForUser: loadCreditForUser,
        onTabClicked: onTabClicked,
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            _self.chooseUser = false;
            _self.selectedUser = data;
            //justo for update object
        });

        this.$topnavbar.$on('closeAddCredit', () => {
            _self.userToAddCredit = null;
        });

        this.$topnavbar.$on('successAddCredit', (data) => {
            _self.userToAddCredit = null;
            _self.loadCreditForUser();
        });

    },
    watch: {
        'selectedUser': function (newVal) {
            if(newVal != null){
                this.loadCreditForUser();
                console.log("watch:selectedUser")
            }
        }
    }
}

function onTabClicked(item){
    this.selectedButton = item;
    this.loadCreditForUser();
}

function chooseUserDialog() {
    this.chooseUser = true;
}

function addCredits() {
    this.userAddCredits = true;
    this.userToAddCredit = this.selectedUser;

}

function takeCredits() {
    this.userAddCredits = false;
    this.userToAddCredit = this.selectedUser;
}


function deleteCredit(company) {
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure_delete_user_credit'),
        text: LocService.t('label_are_you_sure_delete_user_credit_desc'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteUserCredit(company.id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_partner_success_delete'), 'success')
                _self.loadCreditForUser();
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function loadCreditForUser(){
    if(this.selectedUser == null) return;
    console.log("loadCreditForUser")
    let _self = this;
    let active = this.selectedButton === 'ACTIVE' || this.selectedButton === 'USED'
    let used = this.selectedButton === 'USED'
    AdminApiService.getUserCredits(this.selectedUser.id, active, used)
        .then((response) => {
            _self.userCredits = response.data;
            _self.currentCredits = 0;
            response.data.forEach(e => {
                _self.currentCredits = _self.currentCredits + (e.amount - e.amountUsed)
            })
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}


// WEBPACK FOOTER //
// ./src/components/UserCredit/UserCredit.js